/**
 * API 配置文件 - 统一管理所有 API 请求的基础 URL
 * 切换环境时只需要修改这个文件即可
 */

// 本地开发环境
// export const API_BASE_URL = 'http://localhost:8080';

// 测试环境
// export const API_BASE_URL = 'https://tongbuketang_go.xgrok.xdo.icu:443';

// 生产环境
export const API_BASE_URL = 'https://tongbu.flyingcloud.com.cn';
